module.exports = __webpack_public_path__ + "static/media/map-placeholder.7d008d74.svg";